import { CIVS } from '../gameplay/civilisations';
import { loadSimulation, saveSimulation, type SaveData, type Simulation } from '../engine/simulation/simulation';
import { getRecord, putRecord, type StoredRecord } from './db';

function stamp(): string {
  const d = new Date();
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
}

export async function savePlayerGame(sim: Simulation, name?: string): Promise<string> {
  const data = saveSimulation(sim);
  const n = name ?? `Save ${stamp()}`;
  const p = sim.world.players[0];
  const rec: StoredRecord = {
    name: n,
    date: Date.now(),
    meta: { civ: CIVS[p.civ].name, map: sim.config.mapType, minutes: Math.floor(sim.tick / 1200), players: sim.world.players.length },
    data: JSON.stringify(data),
  };
  await putRecord('saves', rec);
  return n;
}

export async function loadPlayerGame(name: string): Promise<Simulation> {
  const rec = await getRecord('saves', name);
  if (!rec) throw new Error('Save not found');
  return loadSimulation(JSON.parse(rec.data) as SaveData);
}

/** Export a save as a downloadable file. */
export function exportSave(rec: StoredRecord): void {
  const blob = new Blob([rec.data], { type: 'application/json' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = `${rec.name.replace(/[^a-z0-9-_ ]/gi, '_')}.easave.json`;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
}
